<template>
  <div class="modal-message">
    <div class="card col-md-12" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Select Verifications</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <el-transfer
            :titles="['Verifications', 'Selected']"
            v-model="selectedVerifications"
            :data="data" />
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="action(selectedVerifications)" class="btn btn-fill btn-wd pull-right"><i class="fa fa-save"/> Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-verification-transfer',
    props: {
      initSelected: {type: Array, default: () => {return []}},
      action: {type: Function},
    },
    data () {
      return {
        data: [],
        selectedVerifications: [],
        loading: false
      }
    },
    mounted: function () {
      this.loading = true
      this.selectedVerifications = this.initSelected.map(v => { return v.id })
      this.$api.getVerificationHistory({size: 500})
        .then(response => {
          this.data = response.data.content.map(v => { return {key: v.id, label: v.fields.firstname + " " + v.fields.surname + " - " + v.instituteName}})
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    }
  }
</script>

<style>

</style>